import { AxiosClient } from 'src/api/AxiosClient';

export class TenantAPI {
  static async getConfig () {
    return AxiosClient.get('/tenant/config');
  }
}
